import React from "react";

const Loader = () => (
  <div className="h-100 w-100 d-flex align-items-center justify-content-center my-5 py-5">
    <div className="spinner-border text-danger" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

export default Loader;
